<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M5,8C5,9.66,6.34,11,8,11C8,11,12.59,11,12.59,11C12.59,11,11.3,9.71,11.3,9.71C11.11,9.53,11,9.28,11,9C11,8.45,11.45,8,12,8C12.28,8,12.53,8.11,12.71,8.29C12.71,8.29,15.71,11.29,15.71,11.29C15.89,11.47,16,11.72,16,12C16,12.28,15.89,12.53,15.71,12.71C15.71,12.71,12.71,15.71,12.71,15.71C12.53,15.89,12.28,16,12,16C11.45,16,11,15.55,11,15C11,14.72,11.11,14.47,11.29,14.29C11.29,14.29,12.59,13,12.59,13C12.59,13,8,13,8,13C5.24,13,3,10.76,3,8C3,8,1,8,1,8C0.447715,8,6.76354e-17,7.55228,0,7C0,7,0,1,0,1C-6.76354e-17,0.447715,0.447715,1.01453e-16,1,1.40865e-32C1,1.40865e-32,7,1.40865e-32,7,1.40865e-32C7.55228,-1.01453e-16,8,0.447715,8,1C8,1,8,7,8,7C8,7.55228,7.55228,8,7,8C7,8,5,8,5,8C5,8,5,8,5,8ZM2,2C2,2,2,6,2,6C2,6,6,6,6,6C6,6,6,2,6,2C6,2,2,2,2,2C2,2,2,2,2,2Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'Inheritance',
} as DefineComponent
</script>
